import { render, staticRenderFns } from "./VocationalApp.vue?vue&type=template&id=27e8f75a&"
import script from "./VocationalApp.vue?vue&type=script&lang=js&"
export * from "./VocationalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports